import React from 'react';
import PropTypes from 'prop-types';
import { GlobalEmptyState } from '~/shared-components';
import { useAccount } from '../../../accountContext';

import { getTypeContent } from '../../utils';

const MissingAccessPage = ({ switchOrganization, translations }) => {
  const user = useAccount();
  const orgWithAccess = user?.organizations?.find(
    (org) => org.billing?.canAccessPublishing
  );
  const orgName = user?.account?.currentOrganization?.name;
  const isAdmin = user?.account?.currentOrganization?.role === 'admin';
  const content = getTypeContent({
    switchOrganization,
    translations,
    isAdmin,
    orgWithAccess,
    orgName,
  });

  return (
    <GlobalEmptyState
      imageSrc="https://buffer-publish.s3.amazonaws.com/images/illustration-publishing.png"
      altText={translations.altText}
      header={translations.heading}
      description={content.description}
      primaryAction={content.primaryAction}
      secondaryAction={content.secondaryAction}
    />
  );
};

MissingAccessPage.propTypes = {
  switchOrganization: PropTypes.func.isRequired,
  translations: PropTypes.shape({
    altText: PropTypes.string,
    heading: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
};

export default MissingAccessPage;
